/** @jsxRuntime classic */
import React from 'react';
import { mdx } from '@mdx-js/react'
/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Para inicializar una aplicación con React solo necesitas importar `}<inlineCode parentName="p">{`react`}</inlineCode>{` y `}<inlineCode parentName="p">{`react-dom`}</inlineCode>{` en el archivo raíz de tu aplicación.`}</p>
    <div {...{
      "className": "remark-highlight"
    }}><pre parentName="div" {...{
        "className": "language-jsx"
      }}><code parentName="pre" {...{
          "className": "language-jsx"
        }}><span parentName="code" {...{
            "className": "token keyword module"
          }}>{`import`}</span>{` `}<span parentName="code" {...{
            "className": "token imports"
          }}><span parentName="span" {...{
              "className": "token maybe-class-name"
            }}>{`React`}</span></span>{` `}<span parentName="code" {...{
            "className": "token keyword module"
          }}>{`from`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'react'`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{`
`}<span parentName="code" {...{
            "className": "token keyword module"
          }}>{`import`}</span>{` `}<span parentName="code" {...{
            "className": "token imports"
          }}><span parentName="span" {...{
              "className": "token maybe-class-name"
            }}>{`ReactDOM`}</span></span>{` `}<span parentName="code" {...{
            "className": "token keyword module"
          }}>{`from`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'react-dom'`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{`
`}</code></pre></div>
    <p>{`Y a continuación debes renderizar el componente principal de tu aplicación en el virtual DOM de React dentro de algún elemento `}<inlineCode parentName="p">{`HTML`}</inlineCode>{`.`}</p>
    <div {...{
      "className": "remark-highlight"
    }}><pre parentName="div" {...{
        "className": "language-jsx"
      }}><code parentName="pre" {...{
          "className": "language-jsx"
        }}><span parentName="code" {...{
            "className": "token maybe-class-name"
          }}>{`ReactDOM`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span><span parentName="code" {...{
            "className": "token method function property-access"
          }}>{`render`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`
  `}<span parentName="code" {...{
            "className": "token tag"
          }}><span parentName="span" {...{
              "className": "token tag"
            }}><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`<`}</span><span parentName="span" {...{
                "className": "token class-name"
              }}>{`App`}</span></span>{` `}<span parentName="span" {...{
              "className": "token punctuation"
            }}>{`/>`}</span></span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{`
  `}<span parentName="code" {...{
            "className": "token dom variable"
          }}>{`document`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span><span parentName="code" {...{
            "className": "token method function property-access"
          }}>{`getElementById`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`'root'`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{`
`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{`
`}</code></pre></div>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;